import { useEffect, useState } from 'react';

/**
 * Shared in-page media popup for the report pages (device-trigger, patrol,
 * attendance). Evidence opens here instead of a new tab, which keeps the
 * report's filters and scroll position intact, and keeps the ?token= query
 * param out of the address bar and browser history.
 *
 * The token still rides on the media URL itself — <img>/<video> can't send an
 * Authorization header — but it never becomes a navigable page.
 *
 * media: { kind: 'image' | 'video', url, title } | null   (null renders nothing)
 */
export default function MediaLightbox({ media, onClose }) {
  const [errored, setErrored] = useState(false);

  // A different item may well exist when the last one didn't — clear the error.
  useEffect(() => { setErrored(false); }, [media]);

  useEffect(() => {
    if (!media) return;
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [media, onClose]);

  if (!media) return null;
  const isVideo = media.kind === 'video';

  return (
    <div className="pk-lightbox" onClick={onClose}>
      <button className="pk-lightbox-close" onClick={onClose} title="Close">✕</button>
      <div onClick={e => e.stopPropagation()} style={{ width: 'min(760px, 92vw)', textAlign: 'center' }}>
        {errored
          ? <div style={{ color: '#fff', padding: 32, background: 'rgba(255,255,255,0.06)', borderRadius: 8 }}>
              This {isVideo ? 'clip' : 'image'} is no longer on disk.
            </div>
          : isVideo
            ? <video src={media.url} controls autoPlay className="pk-lightbox-img"
                style={{ width: '100%' }} onError={() => setErrored(true)} />
            : <img src={media.url} alt={media.title || 'evidence'} className="pk-lightbox-img"
                onError={() => setErrored(true)} />}
      </div>
      {media.title && (
        <div className="pk-lightbox-meta" style={{ color: '#fff', fontSize: 13 }}>{media.title}</div>
      )}
    </div>
  );
}

// Style for a text link that is really a button (opens a popup, not a page).
export const popupLink = link => ({
  ...link, background: 'none', border: 'none', padding: 0, font: 'inherit', cursor: 'pointer',
});
